import {
  AssignmentReturn,
  EditSharp,
  Handshake,
  HandymanOutlined,
  RemoveRedEye,
  Verified
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Routes } from "src/constant/api_url";
import {
  getStockHistoryData,
  returnProductToLVBApi,
  updateProductStatusApi,
  updateReturnStockStatusApi
} from "src/api/commonapi";
import Page from "src/components/Page";
import Select from "react-select";
import AssignProductModal from "./assignProductModal";
import StockInsertUpdateModal from "../StockIn/stockInsertUpdateModal";
import { notification } from "src/utils/messages";
import { IsNotValue, statusLabel } from "src/constant/variable";
import { fetchallcitylist, fetchstockReportCitylist } from "src/utils/common";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Icon } from "@iconify/react";
import { saveAs } from "file-saver";
import CustomLoader from "src/commonComponents/CustomLoader";
import { CSVLink } from "react-csv";
import { useStockUser, useRealUser } from "../CityStockReport/CityStockContext";

export default function ProductHistory({ productHistoryPage, setProductHistoryPage, rowData }) {
  const approveModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  const realUser = useRealUser();
  let loginUser = useStockUser();
  const isStockMode = !!(realUser?.u_type === 0 && loginUser?.u_type === 1);
  const [stockCityList, setStockCityList] = useState([]);
  const [stockCityOverrideId, setStockCityOverrideId] = useState(null);
  if (isStockMode && stockCityOverrideId) {
    loginUser = { ...loginUser, city_id: stockCityOverrideId };
  }
  const csvLinkRef = React.useRef();

  const [isLoading, setIsLoading] = useState(false);

  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(1);
  const [outPage, setOutPage] = useState(1);
  const [returnPage, setReturnPage] = useState(1);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [outRowPerPage, setOutRowsPerPage] = useState(10);
  const [returnRowPerPage, setReturnRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchCall, setSearchCall] = useState(false);
  const [searchClearCall, setSearchClearCall] = useState(false);
  const [stockInCounter, setStockInCounter] = useState(0);
  const [returnStockCounter, setReturnStockCounter] = useState(0);
  const [stockOutCounter, setStockOutCounter] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [modalType, setModalType] = useState("Add");
  const [stockOutRowData, setStockOutRowData] = useState([]);
  const [returnStockRowData, setReturnStockRowData] = useState([]);
  const [stockInRowData, setStockInRowData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [returnStatusConfirmationModal, setReturnStatusConfirmationModal] = useState(false);
  const [returnConfirmationModal, setReturnConfirmationModal] = useState(false);
  const [stockOutModal, setStockOutModal] = useState(false);
  const [stockInModal, setStockInModal] = useState(false);
  const [viewAttachmentModal, setViewAttachmentModal] = useState(false);
  const [returnAttachmentModal, setReturnAttachmentModal] = useState(false);
  const [attachmentData, setAttachmentData] = useState([]);
  const [citylist, setcitylist] = useState([]);
  const initialCityId =
    isStockMode && stockCityOverrideId
      ? stockCityOverrideId
      : loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : rowData?.city_id || -1;
  const [filtereddata, setFilteredData] = useState({
    city_id: initialCityId,
    search: "",
    s_status: -1
  });

  // Sync city filter when navigating between pending chips (Vadodara → Bhavnagar) or product changes
  // Without this, back-button + second chip keeps stale Vadodara in Select Type
  useEffect(() => {
    const newCityId =
      isStockMode && stockCityOverrideId
        ? stockCityOverrideId
        : loginUser?.u_type == 1 ||
            (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : rowData?.city_id || -1;
    if (newCityId !== filtereddata.city_id) {
      const next = { ...filtereddata, city_id: newCityId };
      setFilteredData(next);
      // Auto-refetch for new city/product without requiring Search click
      handleGetStockHistoryData(tabValue, next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginUser?.city_id, rowData?.city_id, rowData?.p_id, stockCityOverrideId, isStockMode]);

  const toggleEditModal = () => setStockOutModal(!stockOutModal);
  const toggleStockInEditModal = () => setStockInModal(!stockInModal);
  const toggleViewAttachmentModal = () => setViewAttachmentModal(!viewAttachmentModal);
  const toggleReturnAttachmentModal = () => setReturnAttachmentModal(!returnAttachmentModal);
  const handleGetStockHistoryData = async (data, filterData, isExport = 0) => {
    setIsLoading(true);
    const resp = await getStockHistoryData({
      p_id: rowData.p_id,
      page: data == 0 ? page : data == 1 ? outPage : returnPage,
      per_page: data == 0 ? rowPerPage : data == 1 ? outRowPerPage : returnRowPerPage,
      tab: data == 0 ? 1 : data == 1 ? 2 : 3,
      city_id: filterData?.city_id || 0,
      login_city_id:
        loginUser?.u_type == 1 || (loginUser?.u_type == 2 && loginUser?.p_user_id != 1)
          ? loginUser?.city_id
          : rowData?.city_id || 0,
      s_date: filterData.s_date,
      e_date: filterData.e_date,
      u_type: loginUser?.u_type,
      p_user_id: loginUser?.p_user_id,
      is_export: isExport,
      s_status: filterData?.s_status
    });
    setIsLoading(false);

    if (isExport) {
      setExportData(resp?.data?.data || []);
      setTimeout(() => {
        csvLinkRef.current.link.click(); // auto download
        setExporting(false);
      }, 100);
      return;
    }
    if (resp.status == 1) {
      setStockData(resp?.data?.data);
      setTotalRows(resp?.data.counter);
      setStockOutCounter(resp.data?.stock_out_counter);
      setReturnStockCounter(resp.data?.return_stock_counter);
      setStockInCounter(resp.data?.stock_in_counter);
    }
  };
  const getallcitylist = async () => {
    setcitylist(
      loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
        ? await fetchallcitylist()
        : []
    );
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    handleGetStockHistoryData(newValue, filtereddata);
  };

  const handleUpdateProductStatus = async (statusData) => {
    setLoader(true);
    const res = await updateProductStatusApi({
      receive_by: loginUser?.name,
      s_h_id: statusData.s_h_id,
      city_id: statusData.city_id,
      city_name: statusData.city_name,
      s_id: statusData.s_id,
      p_id: statusData.p_id,
      p_name: statusData.p_name,
      receive_date: moment().format("DD-MM-YYYY"),
      u_id: loginUser?.u_id,
      p_user_id: loginUser?.u_type == 2 ? loginUser?.p_user_id : loginUser?.u_id,
      qty: statusData.qty,
      amount: statusData.courier_price
    });

    if (res.status != 0) {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
      handleGetStockHistoryData(tabValue, filtereddata);
    } else {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
    }
    setLoader(false);
  };

  const handleUpdateReturnProductStatus = async (statusData) => {
    setLoader(true);
    const res = await updateReturnStockStatusApi({
      s_r_id: statusData.s_r_id,
      p_id: statusData.p_id,
      status: 1,
      approve_date: moment().format("DD-MM-YYYY"),
      qty: statusData.qty
    });
    if (res.status != 0) {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
      handleGetStockHistoryData(tabValue, filtereddata);
    } else {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
    }
    setLoader(false);
  };

  const handleReturnProductToLVB = async (statusData) => {
    setLoader(true);
    const res = await returnProductToLVBApi({
      s_h_id: statusData.s_h_id,
      p_id: statusData.p_id,
      city_id: statusData.city_id,
      qty: statusData.qty,
      u_id: loginUser?.u_id,
      u_name: loginUser?.name
    });

    if (res.status != 0) {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
      handleGetStockHistoryData(tabValue, filtereddata);
    } else {
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
    }
    setLoader(false);
  };

  const handleExportCSV = async () => {
    setExporting(true);
    setIsLoading(true);
    await handleGetStockHistoryData(tabValue, filtereddata, 1);
    setIsLoading(false);
  };

  useEffect(() => {
    handleGetStockHistoryData(tabValue, filtereddata);
  }, [page, outPage, rowPerPage, outRowPerPage]);

  useEffect(() => {
    getallcitylist();
    if (isStockMode) {
      (async () => {
        const list = await fetchstockReportCitylist();
        setStockCityList(list || []);
      })();
    }
  }, []);

  // Fix: Back-button + second chip keeps stale city (Vadodara → Bhavnagar). Sync filtereddata when product or city changes.
  useEffect(() => {
    const newCityId =
      isStockMode && stockCityOverrideId
        ? stockCityOverrideId
        : loginUser?.u_type == 1 ||
            (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : rowData?.city_id || -1;
    if (newCityId !== filtereddata.city_id) {
      const next = { ...filtereddata, city_id: newCityId };
      setFilteredData(next);
      handleGetStockHistoryData(tabValue, next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginUser?.city_id, rowData?.city_id, rowData?.p_id, stockCityOverrideId, isStockMode]);

  const CustomBadges = ({ counter }) => {
    return (
      <div
        style={{
          background: "#034766",
          color: "#fff",
          padding: "2px 10px",
          borderRadius: "10px",
          marginLeft: "5px"
        }}
      >
        <span>{counter != undefined ? counter : 0}</span>
      </div>
    );
  };

  const stockInColumns = [
    { name: "No", selector: (row, index) => index + 1 + (page - 1) * rowPerPage, width: "100px" },
    {
      name: "Date",
      // wrap: true,
      width: "200px",
      selector: (row) => row?.date
    },
    {
      name: "Quantity",
      // wrap: true,
      width: "120px",
      selector: (row) => row?.qty
    },
    ...(loginUser.u_type == 1 || (loginUser.u_type === 2 && loginUser.p_user_id != 1)
      ? [
          {
            name: "Courier Type",
            wrap: true,
            selector: (row) => row?.type_name
          },
          {
            name: "Courier Price",
            wrap: true,
            selector: (row) => row?.courier_price
          },
          {
            name: "Receive Date",
            wrap: true,
            selector: (row) => row?.receive_date
          },
          {
            name: "Status",
            wrap: true,
            selector: (row) =>
              row?.s_status === 0 ? "Pending" : row?.s_status === 1 ? "Received" : "Returned"
          }
        ]
      : []),

    ...(loginUser.u_type == 1 || (loginUser.u_type === 2 && loginUser.p_user_id != 1)
      ? [
          {
            name: "Action",
            wrap: true,
            sortable: true,
            width: "200px",
            selector: (row) => (
              <>
                {/* {loginUser.u_type === 0 ? (
            <Tooltip title="Edit Product">
              <IconButton
                onClick={() => {
                  setModalType("Edit");
                  setStockInRowData({ ...row, p_name: rowData.p_name });
                  toggleStockInEditModal();
                }}
              >
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )} */}
                {loginUser.u_type !== 0 && row?.s_status === 0 ? (
                  <Tooltip title="Receive Stock">
                    <IconButton
                      onClick={() => {
                        setStockInRowData({
                          ...row,
                          p_name: rowData.p_name,
                          p_city_price: rowData.p_city_price
                          // city_name: row.city_name
                        });
                        setConfirmationModal(true);
                      }}
                    >
                      <Icon
                        icon="mdi:hand-coin"
                        width={22}
                        height={22}
                        style={{ color: "green" }}
                      />
                    </IconButton>
                  </Tooltip>
                ) : (
                  ""
                )}

                {loginUser.u_type != 0 ? (
                  <>
                    <Tooltip title="View Attachments">
                      <IconButton
                        onClick={() => {
                          setAttachmentData(row);
                          toggleViewAttachmentModal();
                        }}
                      >
                        <RemoveRedEye color="light" />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}
              </>
            )
          }
        ]
      : [])
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row?.s_status === 0,
      style: {
        backgroundColor: "#FFF9C4", // light yellow
        color: "#000"
      }
    },
    {
      when: (row) => row?.s_status === 1,
      style: {
        backgroundColor: "#86f2baff", // light green
        color: "#000"
      }
    },
    {
      when: (row) => row?.s_status === 2,
      style: {
        backgroundColor: "#FF6363", // light red
        color: "#000"
      }
    }
  ];

  const returnStockConditionalRowStyles = [
    {
      when: (row) => row?.status === 0,
      style: {
        backgroundColor: "#FFF9C4", // light yellow
        color: "#000"
      }
    },
    {
      when: (row) => row?.status === 1,
      style: {
        backgroundColor: "#86f2baff", // light yellow
        color: "#000"
      }
    }
  ];

  const stockOutColumns = [
    {
      name: "No",
      selector: (row, index) => index + 1 + (outPage - 1) * outRowPerPage,
      width: "70px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.date
    },
    {
      name: "Quantity",
      wrap: true,
      selector: (row) => row?.qty
    },
    {
      name:
        loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 1)
          ? "City Name / Guest Name / Member Name"
          : "Member Name / Guest Name",
      wrap: true,
      width: "270px",
      selector: (row) => row?.assign_name
    },
    ...(loginUser.u_type === 0 || (loginUser.u_type === 2 && loginUser.p_user_id === 1)
      ? [
          {
            name: "Status",
            wrap: true,
            selector: (row) =>
              row?.s_status === 0 ? "Pending" : row?.s_status === 1 ? "Received" : "Returned"
          },
          {
            name: "QC Name",
            wrap: true,
            selector: (row) => row?.q_c_name
          },
          {
            name: "Receive Date",
            wrap: true,
            selector: (row) => row?.receive_date
          },
          {
            name: "Action",
            wrap: true,
            sortable: true,
            width: "200px",
            selector: (row) => (
              <>
                {row?.s_status !== 1 &&
                (loginUser.u_type === 0 ||
                  (loginUser.u_type === 2 && loginUser.p_user_id === 1)) ? (
                  <Tooltip title="Edit Stock">
                    <IconButton
                      onClick={() => {
                        setModalType("Edit");
                        setStockOutRowData({ ...row, p_name: rowData.p_name });
                        toggleEditModal();
                      }}
                    >
                      <EditSharp color="warning" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  ""
                )}
                {(loginUser.u_type === 0 ||
                  (loginUser.u_type === 2 && loginUser.p_user_id === 1)) &&
                row?.s_status === 0 &&
                row?.city_id !== 0 ? (
                  <>
                    <Tooltip title="Return Stock">
                      <IconButton
                        onClick={() => {
                          setStockOutRowData({ ...row, p_name: rowData.p_name });
                          setReturnConfirmationModal(true);
                          // !loader && handleReturnProductToLVB(row);
                        }}
                      >
                        <AssignmentReturn color="secondary" />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}
                {loginUser.u_type === 0 || (loginUser.u_type === 2 && loginUser.p_user_id === 1) ? (
                  <>
                    <Tooltip title="View Attachments">
                      <IconButton
                        onClick={() => {
                          setAttachmentData(row);
                          toggleViewAttachmentModal();
                        }}
                      >
                        <RemoveRedEye color="light" />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}
              </>
            )
          }
        ]
      : [
          {
            name: "Assign By",
            wrap: true,
            selector: (row) => row?.assign_user_name
          }
        ])
  ];

  const returnStockColumns = [
    {
      name: "No",
      selector: (row, index) => index + 1 + (returnPage - 1) * returnRowPerPage,
      width: "100px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.date
    },
    {
      name: "Quantity",
      wrap: true,
      selector: (row) => row?.qty
    },
    {
      name: "Receive Date",
      wrap: true,
      selector: (row) => row?.approve_date
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) => (row?.status === 0 ? "Pending" : "Approved")
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          {row?.status === 0 && loginUser?.u_type === 0 ? (
            <Tooltip title="Change Status">
              <IconButton
                onClick={() => {
                  setReturnStockRowData({ ...row, p_name: rowData.p_name });
                  setReturnStatusConfirmationModal(true);
                }}
              >
                <Icon icon="mdi:hand-coin" width={22} height={22} style={{ color: "green" }} />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )}
          {/* {loginUser.u_type == 0 ? ( */}
          <>
            <Tooltip title="View Attachments">
              <IconButton
                onClick={() => {
                  setAttachmentData(row);
                  toggleReturnAttachmentModal();
                }}
              >
                <RemoveRedEye color="light" />
              </IconButton>
            </Tooltip>
          </>
          {/* ) : (
            ""
          )} */}
        </>
      )
    }
  ];

  const stock_in_columns = [
    { label: "Date", key: "date" },
    { label: "Quantity", key: "qty" },
    { label: "Courier Type", key: "type_name" },
    { label: "Courier Price", key: "courier_price" },
    { label: "Receive Date", key: "receive_date" },
    { label: "Status", key: "s_status" }
  ];

  const stock_out_columns = [
    { label: "Date", key: "date" },
    { label: "Quantity", key: "qty" },
    {
      label:
        loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 1)
          ? "City Name / Guest Name / Member Name"
          : "Member Name / Guest Name",
      key: "city_name"
    },
    { label: "QC Name", key: "q_c_name" },
    { label: "Receive Date", key: "receive_date" },
    { label: "Status", key: "s_status" }
  ];

  const return_out_columns = [
    { label: "Date", key: "date" },
    { label: "Quantity", key: "qty" },
    { label: "Receive Date", key: "receive_date" },
    { label: "Status", key: "status" }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.reason != null && data?.reason != "" && (
          <p>
            <b> Reason</b> : {data?.reason}
          </p>
        )}
      </div>
    );
  };

  const stockInExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.description != null && data?.description != "" && (
          <p>
            <b>Description</b> : {data?.description}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <Page title="Product History">
        <Container maxWidth="md">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Product History ({rowData.p_name})
            </Typography>
            <div>
              <Button variant="contained" onClick={() => setProductHistoryPage(false)}>
                Back
              </Button>
            </div>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={3}>
                <Stack spacing={3}>
                  <label style={{ marginBottom: "5px" }}>Select Type</label>
                  <Select
                    value={
                      filtereddata.city_id ==
                      (loginUser?.u_type == 0 ||
                      (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
                        ? -1
                        : parseInt(loginUser?.city_id))
                        ? {
                            value: parseInt(loginUser?.city_id),
                            label: isStockMode
                              ? stockCityList.find((c) => c.city_id == loginUser?.city_id)?.city_name || "My City"
                              : loginUser?.u_type == 0 ||
                                (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
                                ? "All"
                                : "My City"
                          }
                        : filtereddata.city_id == 0
                          ? {
                              value: 0,
                              label:
                                loginUser?.u_type == 0 ||
                                (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
                                  ? "All City"
                                  : "To Member"
                            }
                          : filtereddata.city_id == -2
                            ? {
                                value: -2,
                                label: "To Guest"
                              }
                            : (isStockMode ? stockCityList : citylist).map((city) => {
                                return (
                                  filtereddata.city_id == city.city_id && {
                                    value: city.city_id,
                                    label: city.city_name
                                  }
                                );
                              })
                    }
                    onChange={(e) => {
                      setFilteredData({
                        ...filtereddata,
                        city_id: e.value,
                        chpt_id: 0
                      });
                      setSearchCall(true);
                      if (isStockMode) {
                        setStockCityOverrideId(e.value);
                      }
                    }}
                    menuPortalTarget={document.body}
                    options={[
                      ...(isStockMode
                        ? []
                        : [{
                            value:
                              loginUser?.u_type == 0 ||
                              (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
                                ? -1
                                : parseInt(loginUser?.city_id),
                            label:
                              loginUser?.u_type == 0 ||
                              (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
                                ? "All"
                                : "My City"
                          }]),
                      ...(isStockMode
                        ? []
                        : [{
                            value: 0,
                            label:
                              loginUser?.u_type == 0 ||
                              (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)
                                ? "All City"
                                : "To Member"
                          }]),
                      ...(isStockMode
                        ? []
                        : [{
                            value: -2,
                            label: "To Guest"
                          }]),
                      ...(isStockMode ? stockCityList : citylist).map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack spacing={3}>
                  <label style={{ marginBottom: "5px" }}>Select Status</label>
                  <Select
                    value={statusLabel?.find((opt) => opt.value == filtereddata?.s_status)}
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setFilteredData({
                        ...filtereddata,
                        s_status: e.value
                      });
                      setSearchCall(true);
                    }}
                    options={statusLabel}
                  />
                </Stack>
              </Grid>
              {/* {loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1) ? (
              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label style={{ marginBottom: "5px" }}>Select City</label>
                  <Select
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    value={
                      filtereddata.city_id == -1
                        ? {
                            value: -1,
                            label: "All"
                          }
                        : filtereddata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : filtereddata.city_id == -2
                        ? {
                            value: -2,
                            label: "To Guest"
                          }
                        : citylist.map((city) => {
                            return (
                              filtereddata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                    onChange={(e) => {
                      setFilteredData({
                        ...filtereddata,
                        city_id: e.value,
                        chpt_id: 0
                      });
                      setSearchCall(true);
                    }}
                    options={[
                      {
                        value: -1,
                        label: "All"
                      },
                      {
                        value: 0,
                        label: "All City"
                      },
                      {
                        value: -2,
                        label: "To Guest"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                  />
                </Stack>
              </Grid>
            ) : (
              ""
            )} */}
              <Grid item xs={12} sm={6} md={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label style={{ marginBottom: "5px" }}>Select Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filtereddata.start_date != null
                          ? moment(filtereddata.start_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setSearchCall(true);
                        setFilteredData({
                          ...filtereddata,
                          start_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label style={{ marginBottom: "5px" }}>Select End Date</label>
                    <DatePicker
                      type="date"
                      name="e_date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filtereddata.e_date != null
                          ? moment(filtereddata.e_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setSearchCall(true);
                        setFilteredData({
                          ...filtereddata,
                          e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid
                item
                xs={3}
                style={{
                  marginTop: "7px"
                }}
              >
                <Stack spacing={0}>
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="off"
                    type="text"
                    label="Search"
                    // style={{ marginTop: "23px" }}
                    name="search_text"
                    value={filtereddata.search}
                    onChange={(e) => {
                      setSearchCall(true);
                      setFilteredData({ ...filtereddata, search: e.target.value });
                    }}
                  />
                </Stack>
              </Grid>
              <Grid
                item
                xs={2}
                lg={2}
                md={2}
                sm={2}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  padding: "0",
                  textAlign: "end",
                  marginTop: "13px",
                  marginLeft: "15px"
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    if (searchCall) {
                      handleGetStockHistoryData(tabValue, filtereddata);
                      setSearchClearCall(true);
                    }
                  }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Search
                </Button>
                <Button
                  style={{ marginLeft: "15px" }}
                  variant="contained"
                  onClick={async () => {
                    setFilteredData({
                      city_id:
                        loginUser?.u_type == 1 ||
                        (loginUser?.u_type == 2 &&
                          loginUser?.p_user_id != 1 &&
                          loginUser?.management_p == 1)
                          ? loginUser?.city_id
                          : -1,
                      s_status: -1
                    });
                    if (searchClearCall) {
                      setSearchClearCall(false);
                      handleGetStockHistoryData(tabValue, {
                        city_id:
                          loginUser?.u_type == 1 ||
                          (loginUser?.u_type == 2 &&
                            loginUser?.p_user_id != 1 &&
                            loginUser?.management_p == 1)
                            ? loginUser?.city_id
                            : -1,
                        s_status: -1
                      });
                    }
                  }}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </Card>

          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tabValue} onChange={handleChange}>
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Stock In</span>
                    <CustomBadges counter={stockInCounter} />
                  </Box>
                }
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Stock Out</span>
                    <CustomBadges counter={stockOutCounter} />
                  </Box>
                }
              />
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Return Stock</span>
                    <CustomBadges counter={returnStockCounter} />
                  </Box>
                }
              />
            </Tabs>
          </Box>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px"
              }}
            >
              <Button
                variant="contained"
                // disabled={exporting}
                onClick={handleExportCSV}
                disabled={isLoading || exporting}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                {exporting ? "Exporting..." : "Export CSV"}
              </Button>

              <CSVLink
                ref={csvLinkRef}
                data={exportData}
                headers={
                  tabValue === 0
                    ? stock_in_columns
                    : tabValue === 1
                      ? stock_out_columns
                      : return_out_columns
                }
                filename="Stock_Report.csv"
                style={{ display: "none" }}
              />
            </Box>
            {tabValue === 0 ? (
              <DataTable
                pagination
                highlightOnHover
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={(p) => setPage(p)}
                onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
                columns={stockInColumns}
                data={stockData != null ? stockData : []}
                conditionalRowStyles={conditionalRowStyles}
                expandableRows
                expandableRowsComponent={stockInExpandableRow}
                progressPending={isLoading}
                progressComponent={<CustomLoader />}
              />
            ) : tabValue === 1 ? (
              <DataTable
                pagination
                highlightOnHover
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={(p) => setOutPage(p)}
                onChangeRowsPerPage={(newPerPage) => setOutRowsPerPage(newPerPage)}
                columns={stockOutColumns}
                conditionalRowStyles={
                  loginUser.u_type === 0 || (loginUser.u_type === 2 && loginUser.p_user_id === 1)
                    ? conditionalRowStyles
                    : ""
                }
                data={stockData != null ? stockData : []}
                expandableRows
                expandableRowsComponent={stockInExpandableRow}
                progressPending={isLoading}
                progressComponent={<CustomLoader />}
              />
            ) : (
              <DataTable
                pagination
                highlightOnHover
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={(p) => setReturnPage(p)}
                onChangeRowsPerPage={(newPerPage) => setReturnRowsPerPage(newPerPage)}
                columns={returnStockColumns}
                conditionalRowStyles={returnStockConditionalRowStyles}
                data={stockData != null ? stockData : []}
                expandableRows
                expandableRowsComponent={ExpandableRow}
                progressPending={isLoading}
                progressComponent={<CustomLoader />}
              />
            )}
          </Card>
        </Container>
      </Page>
      {stockOutModal && (
        <AssignProductModal
          assignProductModal={stockOutModal}
          setAssignProductModal={setStockOutModal}
          toggleAssignProductModal={toggleEditModal}
          rowData={stockOutRowData}
          modalType={modalType}
        />
      )}

      {stockInModal && (
        <StockInsertUpdateModal
          addEditModal={stockInModal}
          setAddEditModal={setStockInModal}
          toggleAddEditModal={toggleStockInEditModal}
          rowData={stockInRowData}
          modalType={modalType}
        />
      )}

      <Modal
        open={viewAttachmentModal}
        onClose={() => toggleViewAttachmentModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            height: "400px",
            overflow: "auto"
          }}
        >
          <Typography variant="h6" mb={2}>
            Attachments
          </Typography>

          {/* Dispatch Form */}
          {!IsNotValue.includes(attachmentData?.dispatch_form) ||
          !IsNotValue.includes(attachmentData?.stockin_receipt) ? (
            <>
              {/* Dispatch Form */}
              {attachmentData?.dispatch_form && (
                <Box mb={2}>
                  <Box
                    sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                  >
                    <Typography variant="subtitle1">Dispatch Form</Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        saveAs(
                          `${Routes.API_HOSTNAME}dispatch-form/${attachmentData.dispatch_form}`,
                          attachmentData.dispatch_form
                        )
                      }
                    >
                      Download
                    </Button>
                  </Box>
                  <img
                    src={`${Routes.API_HOSTNAME}dispatch-form/${attachmentData.dispatch_form}`}
                    alt="Dispatch Form"
                    style={{
                      borderRadius: 8,
                      marginTop: 5,
                      width: "200px",
                      height: "200px",
                      objectFit: "contain"
                    }}
                  />
                </Box>
              )}

              {/* Stock In Receipt */}
              {attachmentData?.stockin_receipt && (
                <Box mb={2}>
                  <Box
                    sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                  >
                    <Typography variant="subtitle1">Stock In Receipt</Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        saveAs(
                          `${Routes.API_HOSTNAME}stockin-receipt/${attachmentData.stockin_receipt}`,
                          attachmentData.stockin_receipt
                        )
                      }
                    >
                      Download
                    </Button>
                  </Box>
                  <img
                    src={`${Routes.API_HOSTNAME}stockin-receipt/${attachmentData.stockin_receipt}`}
                    alt="Receipt"
                    style={{
                      borderRadius: 8,
                      marginTop: 5,
                      width: "200px",
                      height: "200px",
                      objectFit: "contain"
                    }}
                  />
                </Box>
              )}
            </>
          ) : (
            <p style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
              There are no attachment
            </p>
          )}
        </Box>
      </Modal>

      <Modal
        open={returnAttachmentModal}
        onClose={() => toggleReturnAttachmentModal()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" mb={2}>
            Attachments
          </Typography>

          {!IsNotValue.includes(attachmentData?.stock_return_attachments) &&
          attachmentData.stock_return_attachments.length > 0 ? (
            <Stack spacing={2} sx={{ height: "400px", overflow: "auto" }}>
              {attachmentData.stock_return_attachments.map((item, index) => {
                const fileUrl = `${Routes.API_HOSTNAME}stock-return-attachment/${item.url}`;
                const isPdf = item.url.toLowerCase().endsWith(".pdf");

                return (
                  <Box
                    key={index}
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}
                  >
                    {fileUrl ? (
                      <img
                        src={fileUrl}
                        alt="Return attachment"
                        style={{
                          borderRadius: 8,
                          marginTop: 2,
                          width: "100px",
                          height: "100px",
                          objectFit: "contain"
                        }}
                      />
                    ) : (
                      ""
                    )}

                    <Stack direction="row" spacing={1}>
                      {/* View */}
                      {/* <Button
                        size="small"
                        variant="outlined"
                        onClick={() => window.open(fileUrl, "_blank")}
                      >
                        View
                      </Button> */}

                      {/* Download */}
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => saveAs(fileUrl, item.url)}
                      >
                        Download
                      </Button>
                    </Stack>
                  </Box>
                );
              })}
            </Stack>
          ) : (
            <Typography align="center">There are no attachments</Typography>
          )}
        </Box>
      </Modal>

      <Modal open={confirmationModal} onClose={() => setConfirmationModal(false)}>
        <Box sx={approveModalStyle}>
          <Typography variant="h6" textAlign="center">
            Are you sure you want to Receive this Product?
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              className="btn btn-primary"
              onClick={async () => {
                handleUpdateProductStatus(stockInRowData);
                setConfirmationModal(false);
              }}
            >
              Yes, Receive
            </Button>
            <Button variant="outlined" onClick={() => setConfirmationModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={returnConfirmationModal} onClose={() => setReturnConfirmationModal(false)}>
        <Box sx={approveModalStyle}>
          <Typography variant="h6" textAlign="center">
            Are you sure you want to Return this Product?
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              className="btn btn-primary"
              onClick={async () => {
                handleReturnProductToLVB(stockOutRowData);
                setReturnConfirmationModal(false);
              }}
            >
              Yes, Return
            </Button>
            <Button variant="outlined" onClick={() => setReturnConfirmationModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={returnStatusConfirmationModal}
        onClose={() => setReturnStatusConfirmationModal(false)}
      >
        <Box sx={approveModalStyle}>
          <Typography variant="h6" textAlign="center">
            Are you sure you want to Receive this Return Product?
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              className="btn btn-primary"
              onClick={async () => {
                handleUpdateReturnProductStatus(returnStockRowData);
                setReturnStatusConfirmationModal(false);
              }}
            >
              Yes, Receive
            </Button>
            <Button variant="outlined" onClick={() => setReturnStatusConfirmationModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
